module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-top'), _vm._v(" "), _c('div', {
    staticClass: "price-library"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "price-library-title"
  }, [_vm._v("报价篮子")]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": _vm.index,
      "mode": "horizontal",
      "active-text-color": "#ffa726"
    },
    on: {
      "select": _vm.handleSelectStatus
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("报价表")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "310px"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03cb4b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PriceLibrary.vue
// module id = 511
// module chunks = 1